import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";
import CompanySwitcher from "@/components/CompanySwitcher";
import useHomeResource from "@/hooks/useHomeResource";
import DadHeader, { DadMobileNav } from "@/components/DadHeader";
export default function Layout() {
 const {user,logout}=useAuth();
 const {companyId,companies,companiesLoaded}=useCompany();
 const navigate=useNavigate();
 const {pathname}=useLocation();
 useEffect(()=>{window.scrollTo(0,0);},[pathname]);
 const health=useHomeResource("/health",companyId,0);
 return <div className="min-h-screen"><a href="#dad-main" className="dad-skip">Vai al contenuto</a>
  <DadHeader companyControl={<CompanySwitcher />} health={health} email={user?.email} onLogout={async()=>{await logout();navigate("/login");}} />
      <main id="dad-main" className="dad-main" tabIndex={-1}>
        {companyId ? (
          <div key={companyId}><Outlet /></div>
        ) : companiesLoaded && companies.length === 0 ? (
          <div className="max-w-md mx-auto px-4 pt-16 text-center" data-testid="no-company-empty">
            <div className="glass rounded-3xl p-8 space-y-4">
              <p className="text-gray-300 font-medium">Non fai ancora parte di nessuna azienda</p>
              <p className="text-xs text-gray-500 leading-relaxed">
                Crea il primo workspace pulito: Il sistema partirà da zero e costruirà la conoscenza
                solo dalle informazioni che fornirai.
              </p>
              <button className="btn-primary w-full" data-testid="no-company-create"
                onClick={() => { document.querySelector('[data-testid="company-switcher-btn"]')?.click(); setTimeout(() => document.querySelector('[data-testid="company-create-open"]')?.click(), 150); }}>
                Crea la prima azienda
              </button>
            </div>
          </div>
        ) : (
          <div className="max-w-6xl mx-auto px-4 pt-16 text-center text-gray-500 text-sm" data-testid="no-company">
            Caricamento workspace…
          </div>
        )}
      </main>
 <DadMobileNav /></div>;
}
